var React = require('react');

function RightArrowIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m7.7843055.08859116.06924789.05785545 3.00000001 3c.1735663.17356635.1928515.44299075.0578554.63785889l-.0578554.06924789-3.00000001 3c-.19526215.19526215-.51184463.19526215-.70710678 0-.17356635-.17356635-.1928515-.44299075-.05785545-.63785889l.05785545-.06924789 2.14655339-2.14644661h-8.793c-.27614237 0-.5-.22385763-.5-.5 0-.24545989.17687516-.44960837.41012437-.49194433l.08987563-.00805567h8.793l-2.14655339-2.14644661c-.17356635-.17356635-.1928515-.44299075-.05785545-.63785889l.05785545-.06924789c.17356635-.17356635.44299075-.1928515.63785889-.05785545z","transform":"translate(2.5 4.5)"}));
}

RightArrowIconInline.defaultProps = {"height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = RightArrowIconInline;

RightArrowIconInline.default = RightArrowIconInline;
